import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  transition-delay: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  transition-delay: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Heading, Link, Box } from "@miro-site/core";
import Grid from "./Grid";
import SecondaryNavigationItem from "./SecondaryNavigationItem";
import styled, { useTheme } from "styled-components";
import HeaderContainer from "./HeaderContainer";
var ViewAllLink = styled(Link).attrs(function(param) {
    var theme = param.theme;
    return {
        $mt: theme.header.secondaryNavigation.viewAllLink.marginTop,
        $variant: theme.header.secondaryNavigation.viewAllLink.variant,
        $color: theme.header.secondaryNavigation.viewAllLink.color,
        withArrow: theme.header.secondaryNavigation.viewAllLink.withArrow,
        $styles: {
            fontSize: theme.header.secondaryNavigation.viewAllLink.fontSize,
            lineHeight: theme.header.secondaryNavigation.viewAllLink.lineHeight
        }
    };
}).withConfig({
    componentId: "sc-344a993f-0"
})(_templateObject());
var SecondaryNavigationWrapper = styled(Box).attrs(function(param) {
    var $isFixed = param.$isFixed, $isExpanded = param.$isExpanded, header = param.theme.header;
    var expandedStyles = {
        pointerEvents: "all",
        visibility: "visible"
    };
    var collapsedStyles = {
        pointerEvents: "none",
        visibility: "hidden"
    };
    return {
        $py: header.secondaryNavigation.verticalPadding,
        $styles: _object_spread({
            position: "absolute",
            zIndex: 8,
            left: 0,
            top: header.height,
            width: "100%",
            maxHeight: "calc(100vh - ".concat(header.bottomLinks.height + header.height, "px)"),
            overflow: "auto"
        }, $isExpanded ? expandedStyles : collapsedStyles)
    };
}).withConfig({
    componentId: "sc-344a993f-1"
})(_templateObject1());
var columnStyles = function(theme, isExpanded, index, nextNavigation) {
    var translateOffset = theme.header.secondaryNavigation.animation.translateOffset;
    var styles = {
        background: theme.header.secondaryNavigation.background,
        transition: theme.header.secondaryNavigation.animation.columns
    };
    if (isExpanded) {
        return _object_spread({
            opacity: 1,
            transform: "translate(0, 0)"
        }, styles);
    }
    if (nextNavigation === null) {
        return _object_spread({
            opacity: 0,
            transform: "translateY(-".concat(translateOffset, "px)")
        }, styles);
    }
    return _object_spread({
        opacity: 0,
        transform: index > nextNavigation ? "translateX(".concat(translateOffset, "px)") : "translateX(-".concat(translateOffset, "px)")
    }, styles);
};
var AnimatedColumn = styled(Grid.Column).withConfig({
    componentId: "sc-344a993f-2"
})(_templateObject2(), function(param) {
    var theme = param.theme, $index = param.$index, $isExpanded = param.$isExpanded, $nextNavigation = param.$nextNavigation;
    return theme.normalizeStyles(columnStyles(theme, $isExpanded, $index, $nextNavigation));
});
var NavigationColumn = styled(AnimatedColumn).withConfig({
    componentId: "sc-344a993f-3"
})(_templateObject3(), function(props) {
    return props.$isExpanded && props.$prevNavigation === null ? props.theme.header.secondaryNavigation.animation.navigationDelay : "0ms";
});
var HighlightedColumn = styled(AnimatedColumn).withConfig({
    componentId: "sc-344a993f-4"
})(_templateObject4(), function(props) {
    return props.$isExpanded && props.$prevNavigation === null ? props.theme.header.secondaryNavigation.animation.highlightedDelay : "0ms";
});
var Headline = styled(Heading).attrs(function(param) {
    var theme = param.theme;
    return {
        as: theme.header.secondaryNavigation.headline.as,
        $my: theme.header.secondaryNavigation.headline.verticalMargin,
        $variant: theme.header.secondaryNavigation.headline.variant
    };
}).withConfig({
    componentId: "sc-344a993f-5"
})(_templateObject5());
var SecondaryNavigation = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    var navigationGroups = props.navigationGroups, highlightedContent = props.highlightedContent, index = props.index, prevNavigation = props.prevNavigation, nextNavigation = props.nextNavigation, restProps = _object_without_properties(props, [
        "navigationGroups",
        "highlightedContent",
        "index",
        "prevNavigation",
        "nextNavigation"
    ]);
    var theme = useTheme();
    var navigationGrid = navigationGroups.length < 3 || highlightedContent ? [
        null,
        null,
        4,
        8,
        12
    ] : [
        null,
        null,
        6,
        12,
        18
    ];
    var navigationGroupGrid = !highlightedContent && navigationGroups.length > 2 ? [
        null,
        null,
        2,
        4,
        6
    ] : navigationGrid.map(function(c) {
        if (c === null) {
            return null;
        }
        return navigationGroups.length > 1 ? c / 2 : c;
    });
    var navigationItemsGrid = [
        null,
        null,
        1,
        2,
        3
    ];
    var highlightedContentGrid = [
        null,
        null,
        2,
        4,
        6
    ];
    var isExpanded = index === nextNavigation;
    return /*#__PURE__*/ _jsx(SecondaryNavigationWrapper, _object_spread_props(_object_spread({}, restProps), {
        "aria-hidden": !isExpanded,
        ref: ref,
        $index: index,
        $prevNavigation: prevNavigation,
        $nextNavigation: nextNavigation,
        $isExpanded: isExpanded,
        children: /*#__PURE__*/ _jsx(HeaderContainer, {
            children: /*#__PURE__*/ _jsxs(Grid, {
                gutter: theme.header.grid.gutter,
                columns: theme.header.grid.columns,
                children: [
                    /*#__PURE__*/ _jsx(NavigationColumn, {
                        $index: index,
                        $prevNavigation: prevNavigation,
                        $nextNavigation: nextNavigation,
                        $isExpanded: isExpanded,
                        columns: navigationGrid,
                        children: /*#__PURE__*/ _jsx(Grid, {
                            gutter: theme.header.grid.gutter,
                            columns: navigationGrid,
                            children: navigationGroups.map(function(n) {
                                return /*#__PURE__*/ _jsxs(Grid.Column, {
                                    columns: navigationGroupGrid,
                                    children: [
                                        /*#__PURE__*/ _jsx(Headline, {
                                            children: n.title
                                        }),
                                        /*#__PURE__*/ _jsx(Grid, {
                                            as: "ul",
                                            gutter: theme.header.grid.gutter,
                                            columns: navigationGroupGrid,
                                            children: n.items.map(function(i) {
                                                return /*#__PURE__*/ _jsx(Grid.Column, {
                                                    as: "li",
                                                    columns: navigationItemsGrid,
                                                    children: /*#__PURE__*/ _jsx(SecondaryNavigationItem, {
                                                        path: i.path,
                                                        title: i.title,
                                                        description: i.description
                                                    }, i.title)
                                                }, i.title);
                                            })
                                        }),
                                        n.viewAllLink && /*#__PURE__*/ _jsx(ViewAllLink, {
                                            href: n.viewAllLink.path,
                                            children: n.viewAllLink.title
                                        })
                                    ]
                                }, n.title);
                            })
                        })
                    }),
                    highlightedContent && /*#__PURE__*/ _jsx(HighlightedColumn, {
                        $index: index,
                        $prevNavigation: prevNavigation,
                        $nextNavigation: nextNavigation,
                        $isExpanded: isExpanded,
                        columns: highlightedContentGrid,
                        children: highlightedContent
                    })
                ]
            })
        })
    }));
});
SecondaryNavigation.displayName = "SecondaryNavigation";
export default SecondaryNavigation;
